import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const loadMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      try {
        const { data } = await api.post("/auth/refresh");
        localStorage.setItem("th_token", data.token);
        const me = await api.get("/auth/me");
        setUser(me.data);
      } catch (e2) {
        localStorage.removeItem("th_token");
        setUser(false);
      }
    }
  };

  useEffect(() => {
    loadMe();
  }, []);

  const accept = (data) => {
    const { token, ...u } = data;
    localStorage.setItem("th_token", token);
    setUser(u);
    return u;
  };
  const login = async (email, password) => accept((await api.post("/auth/login", { email, password })).data);
  const register = async (payload) => (await api.post("/auth/register", payload)).data;
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("th_token");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, register, logout, reload: loadMe }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
